import React from 'react';
import { SvgIcon } from '@mui/material';

// Custom icon that combines clipboard with code brackets <>
const CopyCodeIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      {/* Clipboard outline */}
      <path
        d="M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm7 16H5V5h2v3h10V5h2v14z"
        fill="currentColor"
      />
      {/* Code brackets <> */}
      <text
        x="12"
        y="16"
        fontSize="10"
        fontWeight="bold"
        textAnchor="middle"
        fill="currentColor"
        fontFamily="monospace"
      >
        &lt;&gt;
      </text>
    </SvgIcon>
  );
};

export default CopyCodeIcon;
